module.exports = __webpack_public_path__ + "static/media/aeropath.f42fcf28.svg";